import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { ToastrService } from 'ngx-toastr';
import {
  calculateRiskScore,
  CreateAdvancedSos,
  CreateANPR,
  createComment,
  CreateFace,
  CreateFire,
  CreateIntrusion,
  CreateIntrusionSos,
  CreateManualIncident,
  CreateSOS,
  generateRandomNumber,
  getCriticalRiskHour,
  getHeatMapIncidentData,
  getIncidentGraphData,
  getManualResponderToRequest,
  getMonthRiskStatusData,
  getNonAssetIncidentsData,
  getOrgProperties,
  getOrgUsers,
  getRiskAnalyticsData,
  getServiceRequest,
  locations,
  orgUsers,
} from './aumyeSim.utils';
import { IIncidents } from 'src/app/models/incident';
import { IRequest, IRespond } from 'src/app/models/requests';
import { Observable, Subject, takeUntil } from 'rxjs';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { IRiskQuestions } from 'src/app/models/riskProfile';
import { UserRegDetails } from 'src/app/models/user';
import { IProperty } from 'src/app/models/property';
import { AumyeEmergencyLocationService } from '../aumye-emergency-location.service';
import { ComplaintsTickets } from 'src/app/models/tickets';

@Injectable({
  providedIn: 'root',
})
export class SimulationService {
  destroyed$: Subject<any> = new Subject<any>();
  data$: Observable<IDashboardState>;
  data: IDashboardState;
  orgIncidents: IIncidents[] = [];
  orgComplaints: ComplaintsTickets[] = [];
  orgRequests: IRequest[] = [];
  riskQuestions: IRiskQuestions[] = JSON.parse(localStorage.getItem('Risks'));
  constructor(
    private store: Store<IAumyeState>,
    private toastr: ToastrService,
    private aumyeEmergencyLocationService: AumyeEmergencyLocationService
  ) {
    this.data$ = this.store.select('aumyeDashboardState');
    this.data$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data: IDashboardState) => {
        this.orgIncidents = data.incidentDetails.incidentList;
        this.orgComplaints = data.complaintsTickets;
        this.orgRequests = data.orgSOSData.requests;
      });
  }
  onInitIntrusion() {
    console.log(`Intrusion Service Initated, ${JSON.stringify(new Date())}`);
    this.toastr.success('Intrusion Service Initated', 'Simulation', {
      closeButton: true,
      timeOut: 2500,
      progressBar: true,
      enableHtml: true,
      tapToDismiss: true,
    });
    setInterval(() => {
      console.log(`Intrusion Detected, ${JSON.stringify(new Date())}`);
      let incident: IIncidents = CreateIntrusion();
      let incidentSOS: IRequest = CreateIntrusionSos(incident);
      this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
      this.store.dispatch(new fromDashboardActions.SaveSOSData(incidentSOS));
      this.toastr.success('Intrusion Detected', 'Simulation', {
        closeButton: true,
        timeOut: 2500,
        progressBar: true,
        enableHtml: true,
        tapToDismiss: true,
      });
    }, 1000 * 45); // every 45s
  }
  onCreateManualRobberyIncident() {
    setTimeout(() => {
      console.log(
        `Manual Incident Theft/Pilferage, ${JSON.stringify(new Date())}`
      );
      let incident: IIncidents = CreateManualIncident(
        'Theft/Pilferage',
        `A user's mobile phone was stolen near Gate 2.`,
        'High'
      );
      this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
      this.toastr.success(
        `Theft/Pilferage: \n A user's mobile phone was stolen near Gate 2.`,
        'Simulation Manual Incident ',
        {
          closeButton: true,
          timeOut: 2500,
          progressBar: true,
          enableHtml: true,
          tapToDismiss: true,
        }
      );
    }, 30 * 1000); //30 Seconds
  }
  //////////////////////////////////////////
  onCreateManualRiotIncident(reason: string) {
    console.log(
      `Manual Incident Riot/Protest ${reason}, ${JSON.stringify(new Date())}`
    );
    let incident: IIncidents = CreateManualIncident(
      'Riot/Protest',
      reason,
      'High'
    );
    this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
    // this.toastr.success('Manual Incident Riot/Protest', 'Simulation', {
    this.toastr.success(
      `Riot/Protest:\n ${reason}`,
      'Simulation Manual Incident',
      {
        closeButton: true,
        timeOut: 2500,
        progressBar: true,
        enableHtml: true,
        tapToDismiss: true,
      }
    );
  }
  //////////////////////////////////////////////////
  onCreateFireIncident() {
    setInterval(() => {
      let incident: IIncidents = CreateFire();
      this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
      this.toastr.success('Fire Detected', 'Simulation', {
        closeButton: true,
        timeOut: 2500,
        progressBar: true,
        enableHtml: true,
        tapToDismiss: true,
      });
    }, 2.5 * 60 * 1000);
  }

  private DeviceFailure() {
    console.log(`Device Failure, ${JSON.stringify(new Date())}`);
    let incident: IIncidents = CreateFire();
    this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
    this.toastr.success('Device Failure', 'Simulation', {
      closeButton: true,
      timeOut: 2500,
      progressBar: true,
      enableHtml: true,
      tapToDismiss: true,
    });
  }

  onCreateDeviceFailure() {
    setInterval(() => {
      this.DeviceFailure();
    }, 3 * 60 * 1000);
  }

  private AnprIncident() {
    console.log(`Anpr Detected, ${JSON.stringify(new Date())}`);
    let incident: IIncidents = CreateANPR();
    this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
    this.toastr.success('Anpr Detected', 'Simulation', {
      closeButton: true,
      timeOut: 2500,
      progressBar: true,
      enableHtml: true,
      tapToDismiss: true,
    });
  }

  onCreateAnprIncident() {
    setInterval(() => {
      this.AnprIncident();
    }, 45 * 1000); // every 30 s
  }

  CreateFaceIncident() {
    console.log(`Face Detected, ${JSON.stringify(new Date())}`);
    let incident: IIncidents = CreateFace();
    this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
    this.toastr.success('Face Detected', 'Simulation', {
      closeButton: true,
      timeOut: 2500,
      progressBar: true,
      enableHtml: true,
      tapToDismiss: true,
    });
  }
  onCreateFaceIncident() {
    setInterval(() => {
      this.CreateFaceIncident();
    }, 2 * 60 * 1000);
  }
  onCreateSOSIncident() {
    setTimeout(() => {
      // this.executeSOSIncident();
      this.executeSOSAutoIncident();
      setTimeout(() => {
        this.executeSOSAutoIncident();
        // }, 12 * 60 * 1000); // 12 minutes in milliseconds
      }, 50 * 1000); // 12 minutes in milliseconds
    }, 15 * 1000); // 12 minutes in milliseconds
  }
  onRespondSoSRequest() {
    let incidentRequests: IRequest[] = this.orgRequests.filter(
      (x) => x.isIncident
    );
    let autoRequests: IRequest[] = incidentRequests.filter(
      (x) => (!x.respondData || x.respondData.length === 0) && !x.respondIds
    );

    let randomIndex = generateRandomNumber(autoRequests.length - 1);
    let randomIncidentAuto = { ...autoRequests[randomIndex] };

    let respond: IRespond = getManualResponderToRequest(randomIncidentAuto);
    // let respondIdsList: string[] = [];

    let respondIdsList: string[] = randomIncidentAuto.respondIds
      ? JSON.parse(randomIncidentAuto.respondIds)
      : []; // Parse existing respondIds if present, otherwise start fresh

    let respondData = randomIncidentAuto.respondData
      ? [...randomIncidentAuto.respondData] // Clone the array to make it mutable
      : [];

    respondIdsList.push(respond.respondId);
    respondData.push(respond);

    randomIncidentAuto.respondIds = JSON.stringify(respondIdsList);
    randomIncidentAuto.respondData = respondData;
    this.updateResponderLocations(randomIncidentAuto);
    let indexOfRequest = this.orgRequests.findIndex(
      (x) => x.requestId === randomIncidentAuto.requestId
    );

    if (indexOfRequest !== -1) {
      this.orgRequests = [
        ...this.orgRequests.slice(0, indexOfRequest),
        randomIncidentAuto,
        ...this.orgRequests.slice(indexOfRequest + 1),
      ];
    }
    this.store.dispatch(
      new fromDashboardActions.UpdateSOSData(this.orgRequests)
    );
  }
  executeSOSAutoIncident() {
    let location = locations[generateRandomNumber(locations.length - 1)];
    let incident: IIncidents = CreateSOS(location);
    let incidentSOS: IRequest = CreateAdvancedSos(incident, false);
    this.updateResponderLocations(incidentSOS);
    this.store.dispatch(new fromDashboardActions.SaveIncidentData(incident));
    this.store.dispatch(new fromDashboardActions.SaveSOSData(incidentSOS));
    this.toastr.success('Advanced SoS', 'Simulation', {
      closeButton: true,
      timeOut: 2500,
      progressBar: true,
      enableHtml: true,
      tapToDismiss: true,
    });
  }
  updateResponderLocations(request: IRequest) {
    let responderUser = orgUsers.filter(
      (x) => x.userId == request.respondData[0].respondUserId
    )[0];
    this.aumyeEmergencyLocationService.updateStaticLocation(
      parseFloat(request.respondData[0].longitude),
      parseFloat(request.respondData[0].latitude),
      responderUser
    );
  }
  onInitRiskData() {
    setInterval(() => {
      if (this.orgIncidents.length > 0) {
        let scoreBreakDownData = calculateRiskScore(this.orgIncidents);
        let currentMonthRiskScore = scoreBreakDownData.riskScore;
        let previousMonthRiskScore = 0;
        let totalClosedEvents = this.orgIncidents.filter(
          (x) => x.incidentStatus == 1
        ).length;
        let averageClosedTime =
          totalClosedEvents == 0
            ? 0.0
            : scoreBreakDownData.totalCloseTime / totalClosedEvents;
        let iriskData = getRiskAnalyticsData(this.orgIncidents);
        let riskData = this.riskQuestions;
        if (riskData == null) {
          riskData = JSON.parse(localStorage.getItem('Risks'));
        }
        let riskAnalyticsGraph = iriskData.riskAnalyticsData;
        let riskSingleAnalyticsGraph = iriskData.riskAnalyticsSingleDayData;
        let criticalIncidentsData = {
          highCount: scoreBreakDownData.highCount,
          mediumCount: scoreBreakDownData.mediumCount,
          lowCount: scoreBreakDownData.lowCount,
          highScore: scoreBreakDownData.highScore,
          mediumScore: scoreBreakDownData.mediumScore,
          lowScore: scoreBreakDownData.lowScore,
        };
        let criticalIncidentsCounts = {
          intrusions: scoreBreakDownData.intrusionScore,
          emergencySos: scoreBreakDownData.emergencySosScore,
          fire: scoreBreakDownData.fireScore,
          manual: scoreBreakDownData.manualScore,
        };
        let criticalIncidentsCountNumber = {
          intrusions: scoreBreakDownData.intrusionCount,
          emergencySos: scoreBreakDownData.emergencySosCount,
          fire: scoreBreakDownData.fireCount,
          manual: scoreBreakDownData.manualCount,
        };
        let criticalRiskHour = getCriticalRiskHour(this.orgIncidents);
        let riskAnalyticsStatusGraph = getMonthRiskStatusData(
          this.orgIncidents
        );
        let heatMapData = getHeatMapIncidentData(this.orgIncidents);
        let newHeatMap = getNonAssetIncidentsData(this.orgIncidents);
        heatMapData = [...heatMapData, ...newHeatMap];
        let payload: any = {
          riskAnalyticsGraph: riskAnalyticsGraph,
          riskData: riskData,
          riskSingleAnalyticsGraph: riskSingleAnalyticsGraph,
          criticalIncidentsCounts: criticalIncidentsCounts,
          criticalIncidentsData: criticalIncidentsData,
          criticalIncidentsCountNumber: criticalIncidentsCountNumber,
          averageCloseTime: averageClosedTime,
          currentMonthRiskScore: currentMonthRiskScore,
          previousMonthRiskScore: previousMonthRiskScore,
          criticalRiskHour: criticalRiskHour,
          heatMapData: heatMapData,
          riskAnalyticsStatusGraph: riskAnalyticsStatusGraph,
          totalClaimAmountCurrent: 0,
          totalClaimAmountPrevious: 0,
          previousMonthClaimData: 0,
          currentMonthClaimData: 0,
          riskAnalyticsPreviousMonthGraph: [],
        };
        this.store.dispatch(new fromDashboardActions.SaveRiskData(payload));
      }
    }, 20000);

    // let AVERAGE_CLOSING_TIME = ;
    // let CRITICAL_INCIDENT_COUNT = ;
    // let CRITICAL_RISK_HOUR = ;
    // let DayRiskScore =;let RiskProfile =;let RiskStatusData =; let Risk ScoreBreakdown =; let RiskHeatmap =;
  }
  onCloseSoSRequest(requestId: string) {
    let completedRequest: IRequest = this.orgRequests.find(
      (x) => requestId == x.requestId
    );
    if (completedRequest) {
      let indexOfRequest = this.orgRequests.findIndex(
        (x) => x.requestId === completedRequest.requestId
      );

      if (indexOfRequest !== -1) {
        this.orgRequests = [
          ...this.orgRequests.slice(0, indexOfRequest),
          ...this.orgRequests.slice(indexOfRequest + 1),
        ];
      }
      this.store.dispatch(
        new fromDashboardActions.UpdateSOSData(this.orgRequests)
      );
    }
  }
  onChangeIncidentStatus() {
    let randomMinute = generateRandomNumber(5);

    setInterval(() => {
      const statusMap: any = {
        0: 'Open',
        1: 'Close',
        2: 'Verified',
        3: 'Snoozed',
        4: 'In-Progress',
        5: 'On-Hold',
        6: 'Approved',
        7: 'Rejected',
      };
      if (this.orgIncidents.length > 0) {
        const randomIndex = Math.floor(
          Math.random() * this.orgIncidents.length
        );
        const randomIncident = this.orgIncidents[randomIndex];
        let randomUser: UserRegDetails =
          orgUsers[generateRandomNumber(orgUsers.length - 1)];
        if (randomIncident && randomIncident.incidentStatus === 0) {
          //Open to In-Progress
          let comment = createComment(
            randomIncident.incidentComments,
            `${
              randomUser.firstname + ' ' + randomUser.lastname
            } changed the status from ${statusMap[0]} to ${
              statusMap[4]
            } on ${new Date()}`,
            randomIncident.incidentId
          );
          const updatedIncident: IIncidents = {
            ...randomIncident,
            incidentStatus: 4,
            incidentComments: comment,
            eventInProgressDate: new Date(),
          };
          let statusTimeline = getIncidentGraphData(updatedIncident);
          const NewUpdatedIncident: IIncidents = {
            ...updatedIncident,
            incidentGraph: statusTimeline,
          };

          this.orgIncidents = [
            ...this.orgIncidents.slice(0, randomIndex),
            NewUpdatedIncident,
            ...this.orgIncidents.slice(randomIndex + 1),
          ];
        }
        if (randomIncident && randomIncident.incidentStatus === 4) {
          //In-Progress to 'On-Hold
          let comment = createComment(
            randomIncident.incidentComments,
            `${
              randomUser.firstname + ' ' + randomUser.lastname
            } changed the status from ${statusMap[4]} to ${
              statusMap[5]
            } on ${new Date()}`,
            randomIncident.incidentId
          );
          const updatedIncident: IIncidents = {
            ...randomIncident,
            incidentStatus: 5,
            incidentComments: comment,
            eventOnHoldDate: new Date(),
          };
          let statusTimeline = getIncidentGraphData(updatedIncident);
          const NewUpdatedIncident: IIncidents = {
            ...updatedIncident,
            incidentGraph: statusTimeline,
          };

          this.orgIncidents = [
            ...this.orgIncidents.slice(0, randomIndex),
            NewUpdatedIncident,
            ...this.orgIncidents.slice(randomIndex + 1),
          ];
        }
        if (randomIncident && randomIncident.incidentStatus === 5) {
          //'On-Hold to Verified
          let comment = createComment(
            randomIncident.incidentComments,
            `${
              randomUser.firstname + ' ' + randomUser.lastname
            } changed the status from ${statusMap[5]} to ${
              statusMap[2]
            } on ${new Date()}`,
            randomIncident.incidentId
          );
          const updatedIncident: IIncidents = {
            ...randomIncident,
            incidentStatus: 2,
            incidentComments: comment,
            eventVerifiedDate: new Date(),
          };
          let statusTimeline = getIncidentGraphData(updatedIncident);
          const NewUpdatedIncident: IIncidents = {
            ...updatedIncident,
            incidentGraph: statusTimeline,
          };

          this.orgIncidents = [
            ...this.orgIncidents.slice(0, randomIndex),
            NewUpdatedIncident,
            ...this.orgIncidents.slice(randomIndex + 1),
          ];
        }
        if (randomIncident && randomIncident.incidentStatus === 2) {
          //'Verified to Closed
          let comment = createComment(
            randomIncident.incidentComments,
            `${
              randomUser.firstname + ' ' + randomUser.lastname
            } changed the status from ${statusMap[2]} to ${
              statusMap[1]
            } on ${new Date()}`,
            randomIncident.incidentId
          );
          const updatedIncident: IIncidents = {
            ...randomIncident,
            incidentStatus: 1,
            incidentComments: comment,
            eventClosedDate: new Date().toISOString(),
          };
          let statusTimeline = getIncidentGraphData(updatedIncident);
          const NewUpdatedIncident: IIncidents = {
            ...updatedIncident,
            incidentGraph: statusTimeline,
          };

          this.orgIncidents = [
            ...this.orgIncidents.slice(0, randomIndex),
            NewUpdatedIncident,
            ...this.orgIncidents.slice(randomIndex + 1),
          ];
        }
      }
      this.store.dispatch(
        new fromDashboardActions.UpdateIncidentData(this.orgIncidents)
      );
      // }, randomMinute * 60 * 1000);
    }, 5000);
  }
  onChangeIncidentAssignee() {
    let randomMinute = generateRandomNumber(5);

    setInterval(() => {
      if (this.orgIncidents.length > 0) {
        const randomIndex = Math.floor(
          Math.random() * this.orgIncidents.length
        );
        const randomIncident = this.orgIncidents[randomIndex];
        let randomUser1: UserRegDetails =
          orgUsers[generateRandomNumber(orgUsers.length - 1)];
        let randomUser2: UserRegDetails =
          orgUsers[generateRandomNumber(orgUsers.length - 1)];
        let comment = createComment(
          randomIncident.incidentComments,
          `${
            randomUser1.firstname + ' ' + randomUser1.lastname
          } assigned this ticket from  ${randomIncident.assignedTo} to ${
            randomUser2.firstname + ' ' + randomUser2.lastname
          } on ${new Date()}`,
          randomIncident.incidentId
        );
        const updatedIncident: IIncidents = {
          ...randomIncident,
          incidentComments: comment,
          assignedTo: randomUser2.firstname + ' ' + randomUser2.lastname,
          assignedToUserId: randomUser2.userId,
        };

        this.orgIncidents = [
          ...this.orgIncidents.slice(0, randomIndex),
          updatedIncident,
          ...this.orgIncidents.slice(randomIndex + 1),
        ];

        this.store.dispatch(
          new fromDashboardActions.UpdateIncidentData(this.orgIncidents)
        );
      }
      // }, randomMinute * 60 * 1000);
    }, 15000);
  }

  onCreateProperties() {
    let property: IProperty[] = getOrgProperties();
    this.store.dispatch(new fromDashboardActions.SavePropertyData(property));
  }
  onCreateOrgUsers() {
    let users: UserRegDetails[] = getOrgUsers();
    this.store.dispatch(new fromDashboardActions.SaveUserData(users));
  }
  onCreateServiceRequest() {
    let temp: ComplaintsTickets = getServiceRequest(
      'Service Request',
      'Required a car mechanic tommorow'
    );
    let serviceRequest: ComplaintsTickets[] = [];
    serviceRequest.push(temp);
    this.store.dispatch(
      new fromDashboardActions.SaveComplainData(serviceRequest)
    );
    setTimeout(() => {
      let temp: ComplaintsTickets = getServiceRequest(
        'HouseKeeping',
        'To clean community toilet'
      );
      let serviceRequest: ComplaintsTickets[] = [];
      serviceRequest.push(temp);
      this.store.dispatch(
        new fromDashboardActions.SaveComplainData(serviceRequest)
      );
    }, 30000);
  }
  onUpdateRequest() {
    const statusMap: any = {
      0: 'Open',
      1: 'Close',
      2: 'Verified',
      3: 'Snoozed',
      4: 'In-Progress',
      5: 'On-Hold',
      6: 'Approved',
      7: 'Rejected',
    };
    if (this.orgComplaints.length > 0) {
      // Process first complaint
      setTimeout(() => {
        // Copy original complaints list
        let updatedComplaints: ComplaintsTickets[] = [...this.orgComplaints];
        let randomUser: UserRegDetails =
          orgUsers[generateRandomNumber(orgUsers.length - 1)];
        let comment = createComment(
          updatedComplaints[0].complainIncidentDetails.incidentComments,
          `${
            randomUser.firstname + ' ' + randomUser.lastname
          } changed the status from ${statusMap[0]} to ${
            statusMap[4]
          } on ${new Date()}`,
          updatedComplaints[0].complainIncidentDetails.incidentId
        );
        // Update the first complaint's status
        updatedComplaints[0] = {
          ...updatedComplaints[0],
          complainIncidentDetails: {
            ...updatedComplaints[0].complainIncidentDetails,
            incidentStatus: 4,
            incidentComments: comment,
            eventInProgressDate: new Date(),
          },
        };
        let statusTimeline = getIncidentGraphData(
          updatedComplaints[0].complainIncidentDetails
        );
        // Update the first complaint's status
        updatedComplaints[0] = {
          ...updatedComplaints[0],
          complainIncidentDetails: {
            ...updatedComplaints[0].complainIncidentDetails,
            incidentGraph: statusTimeline,
          },
        };
        // Dispatch the updated complaints list
        this.store.dispatch(
          new fromDashboardActions.UpdateComplainData(updatedComplaints)
        );

        // After 15 seconds, update status to 1 and add evidence
        setTimeout(() => {
          let updatedComplaints: ComplaintsTickets[] = [...this.orgComplaints];
          let randomUser: UserRegDetails =
            orgUsers[generateRandomNumber(orgUsers.length - 1)];
          let comment = createComment(
            updatedComplaints[0].complainIncidentDetails.incidentComments,
            `${
              randomUser.firstname + ' ' + randomUser.lastname
            } changed the status from ${statusMap[4]} to ${
              statusMap[1]
            } on ${new Date()}`,
            updatedComplaints[0].complainIncidentDetails.incidentId
          );
          updatedComplaints[0] = {
            ...updatedComplaints[0],
            complainIncidentDetails: {
              ...updatedComplaints[0].complainIncidentDetails,
              incidentStatus: 1,
              incidentComments: comment,
              eventClosedDate: new Date().toISOString(),
            },
            evidence:
              '[{"FileName":"Puncture-Cropped.jpg","FileType":"image/jpeg","Url":"https://imagetoragelog.blob.core.windows.net/imagefilestorage/images/C%3A%5Clocal%5CTemp%5C37b0377f-39b3-409b-825d-b28ea5be2638.png"}]',
          };
          let statusTimeline = getIncidentGraphData(
            updatedComplaints[0].complainIncidentDetails
          );
          updatedComplaints[0] = {
            ...updatedComplaints[0],
            complainIncidentDetails: {
              ...updatedComplaints[0].complainIncidentDetails,
              incidentGraph: statusTimeline,
            },
          };
          // Dispatch the updated complaints list again with evidence
          this.store.dispatch(
            new fromDashboardActions.UpdateComplainData(updatedComplaints)
          );
        }, 15000);
      }, 5000);

      // Process second complaint after 30-second delay
      setTimeout(() => {
        let updatedComplaints: ComplaintsTickets[] = [...this.orgComplaints];
        // Copy original complaints list again
        // Update the second complaint's status
        let randomUser: UserRegDetails =
          orgUsers[generateRandomNumber(orgUsers.length - 1)];
        let comment = createComment(
          updatedComplaints[0].complainIncidentDetails.incidentComments,
          `${
            randomUser.firstname + ' ' + randomUser.lastname
          } changed the status from ${statusMap[0]} to ${
            statusMap[4]
          } on ${new Date()}`,
          updatedComplaints[0].complainIncidentDetails.incidentId
        );
        updatedComplaints[0] = {
          ...updatedComplaints[0],
          complainIncidentDetails: {
            ...updatedComplaints[0].complainIncidentDetails,
            incidentStatus: 4,
            incidentComments: comment,
            eventInProgressDate: new Date(),
          },
        };
        let statusTimeline = getIncidentGraphData(
          updatedComplaints[0].complainIncidentDetails
        );
        // Update the first complaint's status
        updatedComplaints[0] = {
          ...updatedComplaints[0],
          complainIncidentDetails: {
            ...updatedComplaints[0].complainIncidentDetails,
            incidentGraph: statusTimeline,
          },
        };
        // Dispatch the updated complaints list
        this.store.dispatch(
          new fromDashboardActions.UpdateComplainData(updatedComplaints)
        );

        // After 15 seconds, update status to 1 and add evidence
        setTimeout(() => {
          let updatedComplaints: ComplaintsTickets[] = [...this.orgComplaints];
          let randomUser: UserRegDetails =
            orgUsers[generateRandomNumber(orgUsers.length - 1)];
          let comment = createComment(
            updatedComplaints[0].complainIncidentDetails.incidentComments,
            `${
              randomUser.firstname + ' ' + randomUser.lastname
            } changed the status from ${statusMap[4]} to ${
              statusMap[1]
            } on ${new Date()}`,
            updatedComplaints[0].complainIncidentDetails.incidentId
          );
          updatedComplaints[0] = {
            ...updatedComplaints[0],
            complainIncidentDetails: {
              ...updatedComplaints[0].complainIncidentDetails,
              incidentStatus: 1,
              incidentComments: comment,
              eventClosedDate: new Date().toISOString(),
            },
            evidence:
              '[{"FileName":"WhatsApp Image 2024-10-01 at 11.15.22 AM.jpeg","FileType":"image/jpeg","Url":"https://imagetoragelog.blob.core.windows.net/imagefilestorage/images/C%3A%5Clocal%5CTemp%5Cc14df872-fe61-4958-8ae8-fb482db22884.png"}]',
          };
          let statusTimeline = getIncidentGraphData(
            updatedComplaints[0].complainIncidentDetails
          );
          updatedComplaints[0] = {
            ...updatedComplaints[0],
            complainIncidentDetails: {
              ...updatedComplaints[0].complainIncidentDetails,
              incidentGraph: statusTimeline,
            },
          };
          // Dispatch the updated complaints list again with evidence
          this.store.dispatch(
            new fromDashboardActions.UpdateComplainData(updatedComplaints)
          );
        }, 15000);
      }, 30000); // 30-second delay between processing the first and second tickets
    }
  }
}
// }
